export function generateLoadingSpinner() {
    return $(`<div class="spinner-border text-primary" role="status">` +
        `<span class="sr-only"></span>` +
    `</div>`)
}